<template>
  <div class="upload__block" v-if="valid">
    <div class="action-bar" :class="[showActionBar]">
      <div class="icon-delete" @click.native="deleteBlock('cancel')">
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 1L1 10" stroke="#7D776F" stroke-width="2"/>
          <path d="M1 1L10 10" stroke="#7D776F" stroke-width="2"/>
        </svg>
      </div>
    </div>
    <textarea :class="['text', textHasMaterialClass]" type="text" placeholder="Text" v-model="blockData.text" v-if="!blockData.fileData"></textarea>
    <!-- <div class="or-divider" v-if="!blockData.fileData && !blockData.text">or</div> -->
    <div :class="['fileContainer', hasFileMaterialClass]" v-if="!blockData.text">
      <img :src="blockData.fileUrl" v-if="blockData.fileUrl"/>
      <input id="file-select" type="file" @change="addFiles" multiple="multiple" name="file-select" style="display: none;"/>
      <label for="file-select" class="file-button" v-if="!blockData.fileData">Upload</label>
      <div class="upload-status" v-if="uploadProgress !== '' && uploadProgress != 100">
        <div class="progress-background" :style="{'--progress-size': uploadProgress + '%'}"></div>
        <div class="progress-percent">{{ uploadProgress }}%</div>
      </div>
    </div>
    <div v-if="blockData.fileData || blockData.text">
      <input class="title" type="text" placeholder="Title" v-model="blockData.title" />
      <textarea type="text" placeholder="Description" v-model="blockData.description"></textarea>
      <div class="selects">
        <label :for="typeRadioIdeaId" :class="[selectedIdeaClass]">Idea</label>
        <input type="radio" :name="typeRadioName" :id="typeRadioIdeaId" value="Idea" v-model="blockData.type">
        <br>
        <label :for="typeRadioRefId" :class="[selectedReferenceClass]">Reference</label>
        <input type="radio" :name="typeRadioName" :id="typeRadioRefId" value="Reference" v-model="blockData.type">
        <br>
      </div>
      <div class="selects" v-if="groupCanPipe">
        <label :for="pipeRadioPrivateId" :class="[selectedPrivateClass]">Private</label>
        <input type="radio" :name="pipeRadioName" :id="pipeRadioPrivateId" value="Private" v-model="blockData.pipe">
        <br>
        <label :for="pipeRadioPublicId" :class="[selectedPublicClass]">Public</label>
        <input type="radio" :name="pipeRadioName" :id="pipeRadioPublicId" value="Public" v-model="blockData.pipe">
        <br>
      </div>
    </div>
    <p style="color: orange" v-if="errorMessage"><br>{{ errorMessage }}</p>
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  /* eslint-disable no-useless-escape */
  import { db, storage } from '@trust/firebase'
  import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
  import { collection, doc, setDoc, addDoc, getDoc, getDocs } from "firebase/firestore";
  import { VueCookieNext } from 'vue-cookie-next';
  const axios = require('axios');
  import helpers from '@trust/helpers'

   export default {
      name: 'Uploader',
      data(){
         return{
            blockData: {
             title: '',
             description: '',
             text: '',
             fileData: null,
             fileType: '',
             fileUrl: '',
             uploadedFilename: null,
             // fileStoragePath: '',
             fileRef: null,
             type: 'Idea',
             pipe: 'Private',
             format: '',
            },
            successMessage: '',
            errorMessage: '',
            uploadProgress: '',
            savingMessage: '',
            hasMaterial: false,
         }
      },
      props: ['materialValue', 'valid', 'id'],
      computed: {
        displayFilename() {
          return this.blockData.filename || this.blockData.file.name || '';
        },
        showActionBar(){
          if(this.blockData.fileData || this.blockData.text){
            return 'show--bar';
          } else {
            return '';
          }
        },
        textHasMaterialClass(){
          if(this.blockData.fileData || this.blockData.text){
            return 'has--material';
          } else {
            return '';
          }
        },
        selectedIdeaClass(){
          if(this.blockData.type == 'Idea'){ return 'is--selected'; }
          else { return ''; }
        },
        selectedReferenceClass(){
          if(this.blockData.type == 'Reference'){ return 'is--selected'; }
          else { return ''; }
        },
        selectedPublicClass(){
          if(this.blockData.pipe == 'Public'){ return 'is--selected'; }
          else { return ''; }
        },
        selectedPrivateClass(){
          if(this.blockData.pipe == 'Private'){ return 'is--selected'; }
          else { return ''; }
        },
        typeRadioName(){
          return 'blockType-' + this.id;
        },
        typeRadioIdeaId(){
          return 'ideaType-' + this.id;
        },
        typeRadioRefId(){
          return 'refType-' + this.id;
        },
        pipeRadioName(){
          return 'blockPipe-' + this.id;
        },
        pipeRadioPrivateId(){
          return 'privatePipe-' + this.id;
        },
        pipeRadioPublicId(){
          return 'publicPipe-' + this.id;
        },
        hasFileMaterialClass(){
          if(this.blockData.fileData || this.uploadProgress !== '' || this.blockData.fileUrl){
            return 'fileContainer--with-file'
          }
          return '';
        },
        groupCanPipe(){
          if(this.$store.state.org.piping != null){
            if(this.$store.state.org.piping.arena != undefined){
              return this.$store.state.org.piping.arena.on;
            }
          }
          return false;
        }
      },
      mounted() {
        this.addMaterial(this.materialValue);
      },
      destroyed() {
      },
      methods:{
          getBase64(file) {
            return new Promise((resolve, reject) => {
              try {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
              } catch (err) {
                console.log('getBase64 error', err)
                reject(err)
              }
            });
          },
         async addMaterial(materialValue) {
           let format, filetype;
           if(materialValue.file){
             if(materialValue.file.type == ""){
               // grab filetype from base64 if system didn't have it in the File object
               let base64 = await this.getBase64(materialValue.file);
               filetype = base64.split(';')[0].split(':')[1];
             } else {
               filetype = materialValue.file.type;
             }

             format = filetype.split("/")[0];

           } else if (materialValue.text){
             format = "text";
           } else {
             console.log('No usable data in materialValue');
           }

           console.log(materialValue)
           switch (format) {
            case "text":
              // this should set the description text
              this.blockData.text = materialValue.text;
              this.$store.commit('openNewBlock');
              break;
            case "html":
              console.log('received html somehow')
              break;
            case "image":
            case "video":
            case 'audio':
            case 'application':
              // should start uploading file and display it
              this.blockData.fileData = materialValue.file;
              this.blockData.fileType = format;
              this.blockData.filename = materialValue.file.name;
              this.blockData.title = materialValue.file.name.split('.')[0];
              this.uploadFileToAws();

              this.$store.commit('openNewBlock');
              break;
            default:
              console.log('Oop you need to account for filetype: ', format);
              break;
          }
        },
        addFiles(e){
            // Length of files will be 0 if you close out of file selection prompt
            let files = e.target.files;
            if (files.length > 0) {
              for (let i = 0; i < files.length; i++) {
                if(i == 0) {
                  this.addMaterial({ file: files[i] });
                } else if (i > 0){
                  this.$emit('addFile', { file: files[i] });
                }
              }
            }
        },
        async uploadFileToAws(){
          try {
            let filetype = this.blockData.fileType;
            let contentType = this.blockData.fileData.type;
            let filename = this.blockData.filename;

            this.uploadProgress = 0;
            const urlResponse = await helpers.callServer('POST', this.$store.state.org.activeTrust, this.$store.state.org.baseTenantUrl + '/file/url', {
              filename,
              filetype,
              contentType,
            });
            console.log(urlResponse)

            let uploadUrl = urlResponse.data.url;
            let uploadedFilename = urlResponse.data.filename;
            let file = this.blockData.fileData;

            // let data = new FormData()
            // data.append('file', this.fileData)

            console.log('uploadFile now uploading: ', this.blockData.fileData.type)
            let uploadResponse = await axios.put(uploadUrl, file, {
              headers: {
                "Access-Control-Allow-Origin": "*",
                'Content-Type': this.blockData.fileData.type
              },
              onUploadProgress: function(progressEvent) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                this.uploadProgress = percentCompleted;
              }.bind(this)
            }).catch(function(err){ console.log(err) })

            // let downloadUrl = "https://multi-concept-trust.s3.us-east-2.amazonaws.com/" + encodeURIComponent(uploadedFilename);
            let downloadUrl = "https://d1on0x8owq06rr.cloudfront.net/" + encodeURIComponent(uploadedFilename);
            // Handle successful uploads on complete
            this.blockData.fileUrl = downloadUrl;
            this.blockData.uploadedFilename = uploadedFilename;

          } catch (err) {
            console.log('uploadFile err', err)
            this.errorMessage = err;
            throw err;
          }

        },
        createBlock(uploader, conceptId){
          // Determine Block format and data,
          // format Block object, then save it

          let embedObj = {};
          let videoObj = {};
          let imageObj = {};
          let hyperlinkObj = {};
          let audioObj = {};

          let format;
          let fileUrl = this.blockData.fileUrl;
          // let storagePath = this.blockData.fileStoragePath;
          let uploadedFilename = this.blockData.uploadedFilename;

          // Set block format
          let textValue = this.blockData.text;
          if(textValue) {
            if(this.isURL(textValue)) {
              if(textValue.includes('loom.com')){
                format = 'Embed';
                embedObj = {
                  style: 'Loom',
                  url: textValue
                };

              } else if(textValue.includes('youtube.com') || textValue.includes('youtu.be')){
                format = 'Embed';
                embedObj = {
                  style: 'YouTube',
                  url: textValue
                };

              } else if(textValue.includes('figma.com')){
                format = 'Embed';
                embedObj = {
                  style: 'Figma',
                  url: textValue
                };

              } else {
                format = 'Hyperlink';
                const width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                const height = window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight;
                console.log('sizing for hyperlink: ', width, height);
                hyperlinkObj = {
                  url: textValue,
                  previewWidth: width,
                  previewHeight: height,
                };
              }

            } else {
              format = 'Text';
            }

          } else if (this.blockData.fileUrl) {
            let filetype = this.blockData.uploadedFilename.split(/[#?]/)[0].split('.').pop().trim();
            let videoTypes = ['mov', 'qt', 'mp4', 'm4p', 'm4v', 'webm', 'mpg', 'mp2', 'mpeg', 'mpe', 'mpv', 'ogg', 'avi', 'wmv', 'flv', 'swf', 'avchd']
            let imageTypes = ['image', 'gif', 'jpeg', 'jpg', 'png', 'tif', 'tiff', 'bmp', 'eps', 'raw', 'svg', 'svg+xml']
            let audioTypes = ['mp3', 'wav', 'm4a']
            let pdfTypes = ['pdf']
            let zipTypes = ['zip']
            let objTypes = ['obj', 'glb', 'gltf', 'stl']
            let arrs = [videoTypes, imageTypes, audioTypes, pdfTypes, zipTypes, objTypes];
            arrs.forEach(arr => {
              arr.forEach(item => {
                arr.push(item.toUpperCase());
              })
            })

            // Notes app
            // Text support?
            // Longform
            // Richtext

            if(videoTypes.includes(filetype)){
              format = 'Video';
              videoObj = {
                url: fileUrl,
                uploadedFilename: uploadedFilename,
                filetype: filetype,
              };

            } else if (imageTypes.includes(filetype)) {
              format = 'Image';
              imageObj = {
                url: fileUrl,
                uploadedFilename: uploadedFilename,
                filetype: filetype,
              };

            } else if (audioTypes.includes(filetype)) {
              format = 'Audio';
              audioObj = {
                url: fileUrl,
                uploadedFilename: uploadedFilename,
                filetype: filetype,
              };

            } else if (pdfTypes.includes(filetype)) {
              format = 'Embed';
              embedObj = {
                style: 'PDF',
                url: fileUrl,
                uploadedFilename: uploadedFilename,
                filetype: filetype,
              };

            } else if (objTypes.includes(filetype)) {
              format = 'Embed';
              embedObj = {
                style: '3D',
                url: fileUrl,
                uploadedFilename: uploadedFilename,
                filetype: filetype,
              };

            } else if (zipTypes.includes(filetype)) {
              format = 'Embed';
              embedObj = {
                style: 'ZIP',
                url: fileUrl,
                uploadedFilename: uploadedFilename,
                filetype: filetype,
              };

            } else {
              console.log('NEW FILE TYPE not accounted for ', filetype)
              format = 'Embed';
              embedObj = {
                style: 'Unsupported',
                url: fileUrl,
                uploadedFilename: uploadedFilename,
                filetype: filetype,
              };
            }
          }

          let blockObj = {
            title: this.blockData.title,
            description: this.blockData.description,
            format: format,
            type: this.blockData.type,
            pipe: this.blockData.pipe,
            text: this.blockData.text || '',
            image: imageObj,
            embed: embedObj,
            hyperlink: hyperlinkObj,
            video: videoObj,
            audio: audioObj,
            concepts: [ conceptId ],
            timestamps: {
              gregorian: new Date(),
            },
            uploader: uploader,
          }

          this.$store.commit('createBlock', { blockObj });
        },
        async deleteBlock(reason){
          try {
            if (reason == 'cancel' && this.blockData.uploadedFilename != null) {
              // Delete the file from firebase
              let uploadedFilename = this.blockData.uploadedFilename;
              await helpers.callServer('POST', this.$store.state.org.activeTrust, this.$store.state.org.baseTenantUrl + '/file/delete', { uploadedFilename });
              console.log('File deleted')
              this.$emit('remove');
            } else {
              console.log('No file, removing block')
              this.$emit('remove');
            }

            this.blockData.fileData = null;
            this.blockData.text = '';

          } catch (err) {
            this.errorMessage = err;
            throw err;
          }
        },
        isURL(str) {
          var urlexp = new RegExp('(http|ftp|https)://[a-z0-9\-_]+(\.[a-z0-9\-_]+)+([a-z0-9\-\.,@\?^=%&;:/~\+#]*[a-z0-9\-@\?^=%&;/~\+#])?', 'i');
           if(!!urlexp.test(str) == true){
             try {
               let newUrl = new URL(str); // used to make sure the whole string is the url
               return true;
             } catch {
               return false;
             }
           }
       }
     },
     watch: {
       'blockData.fileData' (to) { // can also be (to, from)
         console.log('checking if removing fileData: ', to)
         if(to == null){
           this.hasMaterial = false;
         } else {
           if(!this.hasMaterial){ this.hasMaterial = true; }
         }
       },
       'blockData.text' (to) {
         if(to == ''){
           this.hasMaterial = false;
         } else {
           if(!this.hasMaterial){ this.hasMaterial = true; }
         }
       },
       'hasMaterial' (to) {
         if(to == true){
           this.$emit('nowHasMaterial')
         } else {
           this.$emit('noLongerHasMaterial')
         }
       },
     }
   }
</script>

<style>

  .upload__block {
    border-radius: 5px;
    margin: 15px;
    box-sizing: border-box;
    overflow: hidden;
    /* box-shadow: 0px 2px 4px 2px rgba(200, 173, 122, 0.29); */
  }

  .upload__block .action-bar {
    background: var(--beige-600);
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    pointer-events: none;
    opacity: 0;
    transition: all 200ms ease-in-out;
  }

  .upload__block .action-bar.show--bar {
    pointer-events: all;
    opacity: 1;
  }

  .upload__block .action-bar .icon-delete {
    height: 100%;
    padding: 0 8px;
    box-sizing: border-box;
    align-self: flex-end;
  }

  .upload__block .icon-delete svg path {
    transition: all 200ms ease-in-out;
  }


  .upload__block .icon-delete:hover {
    cursor: pointer;
  }

  .upload__block .icon-delete:hover svg path {
    stroke: var(--orange-700);
  }

  .upload__block .fileContainer {
    background: var(--beige-600);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    transition: all 100ms ease-in-out;
  }

  .upload__block .fileContainer.fileContainer--with-file {
    height: 150px;
  }

  .upload__block .fileContainer img {
    max-height: 100%;
    width: auto;
    max-width: 100%;
  }

  .upload__block .upload-status {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 150px;
  }

  .upload__block .upload-status .progress-percent {
    z-index: 10;
    position: relative;
    text-align: center;
    font-family: 'Lettera', monospace;
    font-weight: 400;
  }

  .upload__block .progress-background {
    position: absolute;
    z-index: 1;
    --progress-size: 0%;
    bottom: 0;
    width: 100%;
    height: var(--progress-size);
    background: var(--orange-300);
  }

  .upload__block input,
  .upload__block textarea {
    font-family: 'Untitled';
    line-height: 150%;
    padding: 4px 6px;
    background: var(--beige-600);
    border: none;
    border-top: 2px solid var(--beige-300);
    outline: none;
    margin: 0 !important;
  }

  .upload__block textarea {
    resize: vertical;
    display: flex;
  }

  .upload__block .text {
    background: var(--beige-100);
    border: 2px solid var(--beige-600);
    box-sizing: border-box;
    font-size: 14px;
    line-height: 150%;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom: 0;
    transition: all 200ms ease-in-out;
  }

  .upload__block .text.has--material {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .upload__block .title {
    font-weight: 500;
  }

  .upload__block input::placeholder,
  .upload__block textarea::placeholder,
  .upload__block .title::placeholder {
    color: var(--beige-750);
    font-weight: 400;
  }


  .upload__block .selects {
    display: flex;
    flex-direction: row;
    border-top: 2px solid var(--beige-300);
  }

  .upload__block .selects input[type="radio"] {
    -webkit-appearance: none;
    appearance: none;
    opacity: 0;
    position: fixed;
    pointer-events: none;
    margin: 0;
  }

  .upload__block .selects label {
    background: var(--beige-350);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Lettera', monospace;
    font-size: 13px;
    font-weight: 400;
    line-height: 150%;
    color: var(--black);
    padding: 4px;
    margin-bottom: 0;
    transition: all 200ms ease-in-out;
  }

  .upload__block .selects label:hover {
    cursor: pointer;
  }

  .upload__block .selects label.is--selected {
    background: var(--orange-500);
    color: var(--beige-300);
    font-weight: 500;
  }

  .upload__block .selects label:first-of-type {
    border-bottom-left-radius: 5px;
    border-right: 2px solid var(--beige-300);
  }

  .upload__block .selects label:last-of-type {
    border-bottom-right-radius: 5px;
  }

  .upload__block .selects:first-of-type label:first-of-type,
  .upload__block .selects:first-of-type label:last-of-type {
    border-radius: 0;
  }

  .upload__block .or-divider {
    text-align: center;
    font-style: italic;
    background: var(--beige-600);
    padding: 0px 0 3px 0;
    color: var(--beige-750);
    line-height: 150%;
    width: 100%;
    box-sizing: border-box;
  }

  .upload__block .file-button {
    width: 100%;
    margin: 8px;
    padding: 4px 8px;
    border-radius: 2.5px;
    text-align: center;
    background: var(--beige-100);
    border: 1px solid var(--beige-350);

    /* font-family: 'Lettera', monospace; */
    font-family: 'Untitled', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    color: var(--black);
    cursor: pointer;
  }

</style>
